import * as Config from '../config';
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { setRequestError } from "../actions/index";

// RAW Response without a structure
const useRaw = (id, pathApi, perPage = 100, type) => {
  const api = useSelector(state => state.api);
  const dispatch = useDispatch();
  const [response, setResponse] = useState(null);

  useEffect(() => {
    if (api && pathApi) {
      api.getFromApi(pathApi, false).then( res => {
        const results = res.data;

        let itemsFormatted = [];
        if (type === 'artist') {
          itemsFormatted = [...results].splice(0, perPage).map(Config.formattedArtist);
        }
        if (type === 'label') {
          itemsFormatted = [...results].splice(0, perPage).map(Config.formattedLabel);
        }

        setResponse({
          id,
          itemsFull: itemsFormatted,
          items: itemsFormatted,
          next: res.data.next,
          pagination: {},
          loading: false,
          onLoadMore: null,
        });

      }).catch( e => {
        const sError = JSON.parse(JSON.stringify(e, null, 2));
        if (sError && sError.message && sError.message.includes(`401`)) { // Session Expired
          dispatch(setRequestError(sError));
        }
        setResponse({ id, itemsFull: [], items: [], next: null, pagination: {}, loading: false, onLoadMore: null })
      } );
    }
  }, [id, pathApi, type, api, perPage, dispatch])

  return [response];
};

export default useRaw;
